import { useEffect, useState } from 'react';
import './homeScrollCue.css';

/**
 * Desktop-only "See how it works ↓" cue at the bottom of the homepage hero, so visitors know the page
 * keeps going. Shows only when the next section starts below the fold, fades for good once the visitor
 * scrolls, and is hidden on phones (the bottom sign-up bar owns that edge). Styles: homeScrollCue.css.
 */
export function HomeScrollCue({ targetSelector = '.demoband' }: { targetSelector?: string }) {
  const [show, setShow] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t = window.setTimeout(() => {
      // The next section may not have mounted yet (it can load lazily); if it's missing, it's below the fold.
      const el = document.querySelector(targetSelector);
      const below = !el || el.getBoundingClientRect().top > window.innerHeight - 40;
      if (below && window.scrollY < 40) setShow(true);
    }, 300);
    const onScroll = () => window.scrollY > 40 && setGone(true);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.clearTimeout(t);
      window.removeEventListener('scroll', onScroll);
    };
  }, [targetSelector]);

  if (!show) return null;
  const reduce = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  return (
    <button
      type="button"
      className={`home-cue${gone ? ' is-gone' : ''}`}
      aria-hidden={gone}
      tabIndex={gone ? -1 : 0}
      onClick={() => {
        const el = document.querySelector(targetSelector) ?? document.getElementById('hero')?.nextElementSibling;
        el?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }}
    >
      See how it works
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 5v14M6 13l6 6 6-6" />
      </svg>
    </button>
  );
}
